// extracted by mini-css-extract-plugin
export default {"link":"TextLink_link__wN9cf","text":"TextLink_text__XAOoB"};